"use client";
import { useEffect, useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import React from "react";
import { cn } from "../lib/utils";

export const aboutTexts = [
  "Expert at Building modern web applications with cutting-edge technologies and cloud tools",
  "3+ YOE in developing dynamic web applications and on-cloud solutions",
  "I excel at crafting elegant digital experiences and I am proficient in various programming languages and technologies",
  "I am a passionate Web Developer with good experience in Typescript and crucial skills based in Tunisia",
  "I excel in crafting elegant digital experiences and am proficient in various programming languages and technologies.",
  "With over three years of professional experience, including both remote and on-site roles",
  "I specialize in developing and optimizing software solutions to turn ideas into reality",
  "My technical expertise includes TypeScript, React.js, and Next.js",
  "I have a proven track record of transforming concepts into functional web applications.",
  "I am fluent in English and French, and known for my strong communication skills.",
];

export const typewriterTexts = [
  "Computer Software Engineer and Full Stack Web Developer with over 3 years of experience in architecting and developing cloud-native web applications",
  "Proficient in the MERN stack, and Next.js, alongside extensive experience with cloud platforms such as AWS, Azure",
  "Proficiency in Python (FastApi, Django), C# (Asp.Net) & Java (Spring Boot)",
  "Integrating APIs (GraphQL, REST), and enabling real-time data exchange via WebSocket",
  "Experienced in containerizing microservices with Docker, solving advanced real-time tasks, writing clean and scalable code, optimizing performance, and driving the end-to-end delivery of projects.",
  "Skilled in Team Work, writing clean code, deploying and maintaining applications",
  // "Computer Software Engineer & Highly Skilled Full Stack Web Developer",
  // "Cloud Specialist Working on cloud native applications with Aws, Gcp and Azure",
  // "Experienced in Mern Stack, Next.js, PostgreSql",
  // "Worked with React, Node.js, Express.js, MongoDB",
  // "Building Scalable Web Applications with Graphql, Rest and Websocket Apis",
  // "Containerization with Docker & Automation, CI/CD Pipelines",
  // Skilled in Python (FastAPI), C# (ASP.NET), and Java (Spring Boot). Expertise in automating CI/CD pipelines, integrating APIs
  // (GraphQL, REST), and enabling real-time data exchange via WebSocket. Experienced in containerizing microservices with Docker, solving
];

export const typewriterShortTexts = [
  "Software Engineer",
  "FullStack Web Developer",
  "Data Engineer",
  "Cloud Specialist",
  "Tester",
  // "Devops Developer",
  // "UI/UX Designer",
  // "Data Engineer",
  // "Problem Solver",
];

export const typewriterIntroTexts = [
  `I have professional experience of more than three years and half in company B2b Alive Ltd`,
  "I excel at crafting elegant digital experiences and I am proficient in various programming languages and technologies",
  "I'm passionate software Engineer & Full-Stack Web Developer From Tunisia",
  "My expertise lies in developing and optimizing software solutions to turn ideas into reality.",
  "With over three years of professional experience, including remote work and on-site roles",
  "I am expert In Typescript, ReactJs Library and NextJs Framework",
  "My expertise lies in developing and optimizing software solutions to turn ideas into reality.",
  "I can transform your ideas into reality using my expertise in diverse web development technologies and tools",
  "I have a passion for turning lines of code into meaningful projects and design elegant web responsive applications",
  "I speak Fluent English and French and good communicator",
  "I build amazing user experiences in any language",
  "I have Knowledge in services like aws, google cloud and azure , plus virtualization with docker and kubernetes",
];

export function TypewriterText({
  texts = aboutTexts,
  className,
}: {
  className?: string;
  texts?: string[];
}) {
  return (
    <div
      className={cn(
        "text-lg text-center font-semibold tracking-wide overflow-hidden mx-auto text-ellipsis break-words",
        className
      )}
    >
      {/* <div className='relative mx-auto max-h-[80px] max-w-full overflow-hidden'> */}
      <Typewriter
        words={texts}
        loop={true}
        cursor={false}
        cursorBlinking={false}
        // cursorStyle="|"
        cursorStyle="🚀"
        typeSpeed={10}
        deleteSpeed={5}
        delaySpeed={4000}
        cursorColor="red"
      />
      <span className="animate-blink"> |</span>
    </div>
  );
}

export function TypewriterManual({
  texts = typewriterIntroTexts,
}: {
  texts?: string[];
}) {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);

  useEffect(() => {
    const handleTyping = () => {
      const currentText = texts[loopNum];
      const shouldDelete = isDeleting;

      setText(
        shouldDelete
          ? currentText.substring(0, text.length - 1)
          : currentText.substring(0, text.length + 1)
      );

      setTypingSpeed(shouldDelete ? 30 : 150);

      if (!shouldDelete && text === currentText) {
        setTimeout(() => setIsDeleting(true), 500);
      } else if (shouldDelete && text === "") {
        setIsDeleting(false);
        setLoopNum((loopNum + 1) % texts.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, typingSpeed]);

  return (
    <span className="text-lg text-gray-800 dark:text-gray-400 my-2">
      {text}
      <span className="animate-blink">|</span>
    </span>
  );
}

// const wordsByLanguage: { [locale: string]: string[] } = {
//   en: [
//     "Hi, My name is Hamza Missaoui",
//     "I am software engineer and web developer who loves",
//     "I love programming and design elegant web applications",
//     "I have advanced knowledge in typescript, react, next and node",
//     "Knowledge on variety of frameworks like react, next js , django and spring boot",
//     "Knowledge in aws cloud serivces and docker containerisation",
//   ],
//   fr: [
//     "Salut, je m'appelle Hamza Missaoui",
//     "Je suis ingénieur génie logiciel et développeur web",
//     "Je travaille sur des fullstack applications web responsives avec graphql et rest api",
//     "J'ai des connaissances avancés en différents langages comme typescript python et java",
//     "Aussi frameworks comme react, next js , django et spring boot",
//     "Connaissances en aws cloud serivces et docker conteneurisation",
//   ],
//   ar: [
//     "مرحبا، اسمي حمزة ميساوي",
//     "أنا مهندس برمجيات ومطور ويب أحب",
//     "أنا أحب البرمجة وتصميم تطبيقات الويب الأنيقة",
//     "لدي معرفة متقدمة في الآلة الكاتبة والتفاعل والتالي والعقدة",
//     "المعرفة بمجموعة متنوعة من أطر العمل مثل رد الفعل، وjs التالي، وجانغو، والتمهيد الربيعي",
//     "المعرفة في الخدمات السحابية لـ aws وحاويات الإرساء",
//   ],
// };
